import {
  Company,
  ContactUs,
  CustomerAcceptance,
  Error404Page,
  Landing,
  PrivacyPolicy,
  TermsOfService,
} from 'features/misc';
import { useRoutes } from 'react-router-dom';

export const AppRoutes = () => {
  const commonRoutes = [
    { path: '/', element: <Landing /> },
    { path: '/contact', element: <ContactUs /> },
    { path: '/company', element: <Company /> },
    { path: '/terms-of-service', element: <TermsOfService /> },
    { path: '/privacy-policy', element: <PrivacyPolicy /> },
    { path: '/customer-acceptance', element: <CustomerAcceptance /> },

    { path: '*', element: <Error404Page /> },
  ];

  const element = useRoutes([...commonRoutes]);

  return <>{element}</>;
};
